import { render, staticRenderFns } from "./OrganPersonContactInfoEdit.vue?vue&type=template&id=a93b589c&scoped=true"
import script from "./OrganPersonContactInfoEdit.vue?vue&type=script&lang=js"
export * from "./OrganPersonContactInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93b589c",
  null
  
)

export default component.exports